import { render } from "./IconSpin.vue?vue&type=template&id=6853a220"
import script from "./IconSpin.vue?vue&type=script&lang=js"
export * from "./IconSpin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__